import { Condition, PrivacyPolicy } from "../../pages";
import { PrivacyPolicyModalStyle } from "./PrivacyPolicyModal.style";

interface PoliciesProps {
  isModalVisible?: boolean;
  setIsModalVisible?: (_: boolean) => void;
  setName?: "policy" | "condition";
}

const Policies = ({ isModalVisible, setIsModalVisible, setName }: PoliciesProps) => {
  const handleCancel = (e: React.MouseEvent) => {
    e.stopPropagation();
    setIsModalVisible?.(false);
  };

  const isPrivacyPolicy = setName === "policy";
  const title = isPrivacyPolicy ? "Privacy Policy" : "Terms & Conditions";

  return (
    <PrivacyPolicyModalStyle
      visible={isModalVisible}
      onOk={() => setIsModalVisible?.(false)}
      footer={null}
      onCancel={handleCancel}
    >
      <div>
        <h1 className="heading">{title}</h1>
        {isPrivacyPolicy ? <PrivacyPolicy /> : <Condition />}
      </div>
    </PrivacyPolicyModalStyle>
  );
};

export default Policies;
